import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { environment } from '../../environments/environment';

// 2024-08-29: DO NOT USE installed firebase sdk as it has since depreciated
// import * as firebase from 'firebase';   

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { FcmMessage, User } from '../models';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AdminService } from './admin.service';
import { SessionService } from './session.service';
import { getElement } from '@syncfusion/ej2-angular-charts';

@Injectable()
export class MessagingService {

    deviceRegistered: boolean = false;
    messaging:any = document["fb_messaging"];
    //messaging = this.firebase.messaging();
    currentFcmMessage = new BehaviorSubject(null);
    currentRegisteredDevice = new BehaviorSubject(null);
    messagingNotificationEnabled = new BehaviorSubject(null);

    constructor(
        private afDb: AngularFireDatabase,
        private afAuth: AngularFireAuth,
        private authService: AuthService,
        private adminService: AdminService,
        private sessionService: SessionService
    ) {
        this.authService.currentUser.subscribe(currentUser => {
            if (currentUser && currentUser.ID && this.adminService.isMessageServiceEnabled(currentUser)) {
                this.sessionService.log("FCM getPermission");
                this.getPermission(currentUser, this.messagingNotificationEnabled);
                this.receiveMessage(currentUser, this.currentFcmMessage, this.sessionService);
            }
        });
    }

    updateToken(token) {
        this.afAuth.authState.take(1).subscribe(user => {
            if (!user) return;
            const data = { [user.uid]: token }
            this.afDb.object('fcmTokens/').update(data);
        })
    }

    getPermission(currentUser: User, messagingNotificationEabled: BehaviorSubject<boolean>) {
        this.messaging.getToken()
        //this.messaging.requestPermission()
            .then((token) => {
                this.sessionService.log("Notification permission granted.");
                console.log("Notification permission granted.");
                this.messagingNotificationEnabled.next(true);
                //return this.messaging.getToken();
                return token;
            })
            .then(token => {
                this.sessionService.log(token);
                if (!this.deviceRegistered) {
                    this.adminService.registerDevice(currentUser, token).subscribe(
                        device => {
                            this.sessionService.log("Device Registered.", device);
                            console.log("Device Registered.", device);
                            this.deviceRegistered = true;
                            this.currentRegisteredDevice.next(device);
                        },
                        err => { 
                            this.sessionService.log("uanble to register device", err) 
                            console.log("uanble to register device.", err);
                        }
                    )
                }
                this.updateToken(token);
            })
            .catch((err) => {
                this.sessionService.log("unable to get permission to notify.", err);
                console.log("unable to get permission to notify.", err);
                this.messagingNotificationEnabled.next(false);
            });
    }

    removePreviousRegisteredDevices(user: User, currentRegisteredDevice: any) {
        this.adminService.listMyDevices(user).subscribe(
            devices => {
                devices.forEach(d => {
                    // remove all previous registered device except curRegisteredDevice
                    if (d.ID != currentRegisteredDevice.ID && d.model_category == 'Web') {
                        this.adminService.deleteDevice(user, d.ID).subscribe(
                            result => { this.sessionService.log("device removed: ", result); },
                            err => { this.sessionService.log("uanble to delete device: ", err); }
                        )
                    }
                })
            },
            err => { this.sessionService.log("uanble list my FCM devices", err) }
        )
    }

    receiveMessage(currentUser: User, message: BehaviorSubject<any>, sessionService: SessionService) {
        // 2020-02-07: onMessage does not work, try again when we upgrade angular to 6+
        // this.messaging.onMessage((payload) => {
        //   this.sessionService.log("Message received. ", payload);
        //   //this.currentMessage.next(payload);
        // });

        if ('serviceWorker' in navigator) {
            //this.sessionService.log("registering firebase-messaging-sw.js serviceWorker");
            // WARNING: register firebase-messaging-sw.js will create another sw within application.. 
            //navigator.serviceWorker.register('firebase-messaging-sw.js');
            navigator.serviceWorker.ready.then(function (reg) {
                // PING to service worker, later we will use this ping to identifies our client. reg.active is the active sw
                var fcmPing: FcmMessage = { type: "src-to-sw-ping", user: currentUser, data: null };
                reg.active.postMessage(JSON.stringify(fcmPing));
            });

            // add sw message listener for active and bg fcm push messages
            navigator.serviceWorker.addEventListener('message', function handler(event) {
                try {
                    var msg = null;
                    if (event.data.firebaseMessaging) {
                        msg = event.data.firebaseMessaging.payload;
                    } else if (event.data.data) {
                        msg = event.data;
                    } else {
                        msg = JSON.parse(event.data);
                    }
                    message.next(msg);
                    sessionService.log("Received a message from sw", msg);
                } catch (e) {
                    sessionService.log("unable to parse FCM message!", event.data);
                }
            });

            // setTimeout(() => {
            //   if (msg) {
            //     this.currentMessage.next(msg);
            //     msg = null;
            //   }
            // }, 100);
        }
    }

    public playSound(type: string = ''): void {
        var audio = new Audio();
        audio.src = "../../../assets/audio/when.mp3";
        audio.load();
        audio.play();
    }

    public setFavicon(icon: string = ''): void {
        var lkFavicon = document.getElementById("lkFavicon");
        if (lkFavicon) {
            if (icon) {
                lkFavicon["href"] = icon;
            } else {
                lkFavicon["href"] = "favicon";
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/messaging.service.ts